import { Select } from '@mantine/core'
import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { getAvailableEmitterTypes } from 'App/Map/_utils/getAvailableEmitterTypes'
import { translate } from 'i18n/i18n'
import { useEffect } from 'react'
import { SharedSettings } from 'settings/SharedSettings'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import { mapSelectedCardStore } from 'stores/mapSelectedCardStore/mapSelectedCardStore'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'
import { sortByKey } from 'utils/sortByKey'

export const EmitterSelect = () => {
  const { properties } = fieldAssetStore.useSelector((s) => s)
  const selectedEmitters = mapControlsStore.useSelector((s) => s.selectedEmitters)
  const availableEmittersSet = getAvailableEmitterTypes(properties)

  useEffect(() => {
    mapControlsStore.setState((s) => ({
      ...s,
      selectedEmitters: ['emitter-drip-1'],
    }))
  }, [])

  return (
    <Select
      data={availableEmittersSet
        .map((emitter) => ({
          label: mapApiEmitterTypeToLabel(emitter),
          value: emitter,
        }))
        .sort(sortByKey('label'))}
      onChange={(emitter) => {
        mapControlsStore.setState((s) => ({
          ...s,
          selectedEmitters: [emitter as TEmitterType],
        }))

        mapSelectedCardStore.actions.hide()
      }}
      placeholder={translate.phrases.banyanApp('Select Emitter Type')}
      value={selectedEmitters[0]}
      styles={SharedSettings.MANTINE_SELECT_RIGHT_ICON_CHANGER}
    />
  )
}
